import BannerComponent from './component'
export default BannerComponent
